import { useEffect, useMemo, useState } from "react";
import { notification } from "antd"
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import ProfilePicture from '../molecules/global/ProfilePicture'
import AuthLayout from './AuthLayout';

import { acceptWorkspaceInvite, getUser, getWorkspaceInvites, getWorkspaces } from "../../../actions";
import { setUnauthorized } from "../../../actions/userAction";

export const SetupAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector(state => state.userReducer.user);

  const [workspaces, setWorkspaces] = useState([]);
  const [invites, setInvites] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      dispatch(getUser());
      const w = await dispatch(getWorkspaces('lean'));
      const invites = await dispatch(getWorkspaceInvites());
      setInvites(invites);
      setWorkspaces(w);
    };
    loadData();
  }, []);

  useEffect(() => {
    const url = window.location.href;
    if (!localStorage.getItem('token')) {
      dispatch(setUnauthorized('Session Expired!'));
      navigate('/', { replace: true });
    } else {
      const splitUrl = url.split('inviteId=');
      if (splitUrl.length > 1) {
        const inviteId = splitUrl[1].split('&')?.[0] || '';
        if (inviteId) {
          dispatch(acceptWorkspaceInvite(inviteId)).then((res) => {
            if (res?._id) {
              notification.success({ message: 'Workspace Joined!', placement: 'bottomRight' });
              setWorkspaces(prev => [...prev, res]);
            }
          });
        }
      }
    }
  }, []);

  return (
    <AuthLayout>
      {/* Email badge */}
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', borderRadius: 8, background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
          </svg>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>{user?.email}</span>
        </div>
      </div>

      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: 'rgba(255,255,255,0.95)', margin: '0 0 6px' }}>
          Add a profile picture
        </h2>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', margin: 0 }}>
          Optional — you can always change this later.
        </p>
      </div>

      {/* Avatar */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, marginBottom: 36, padding: '28px 20px', borderRadius: 16, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
        <ProfilePicture user={user} />
      </div>

      {/* Continue */}
      <button
        onClick={() => navigate((workspaces?.length > 0 || invites?.length > 0) ? '/select-workspace' : '/create-workspace', { replace: true })}
        className="gs-btn-primary"
        style={{
          width: '100%', padding: '12px 0', fontSize: 14, fontWeight: 600,
          borderRadius: 10, border: 'none', color: 'white',
          background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
          boxShadow: '0 4px 20px rgba(99,102,241,0.4)',
          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          transition: 'filter 0.15s, box-shadow 0.15s, transform 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.12)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
        onMouseLeave={e => { e.currentTarget.style.filter = ''; e.currentTarget.style.transform = ''; }}
      >
        <FormattedMessage id="CONTINUE" defaultMessage="Continue" />
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 8h10M9 4l4 4-4 4" />
        </svg>
      </button>
    </AuthLayout>
  );
};
